import { Mixpanel } from '/@/core/mixpanel';
import { EVENTS as ACTIVITIES_EVENTS } from './events/activities';
import { EVENTS as ASK_AN_EXPERT_EVENTS } from './events/ask-an-expert';
import { EVENTS as CARBON_CALCULATOR_EVENTS } from './events/carbon-calculator';
import { EVENTS as CATALOG_EVENTS } from './events/catalog';
import { EVENTS as SEED_QUALITY_EVENTS } from './events/corn-seed-quality';
import { EVENTS as CROP_MOITORING_EVENTS } from './events/crop-monitoring';
import { EVENTS as CROP_PROTECTION_EVENTS } from './events/crop-protection';
import { EVENTS as FIELD_REGISTRY_EVENTS } from './events/field-registry';
import { EVENTS as FIELD_EVENTS } from './events/fields';
import { EVENTS as GROWERS_EVENTS } from './events/growers';
import { EVENTS as H2H_EVENTS } from './events/h2h';
import { EVENTS as MAPS_EVENTS } from './events/maps';
import { EVENTS as N_SMART_RECOMMENDATION_EVENTS } from './events/n-smart-recommendation';
import { EVENTS as NOTIFICATIONS_EVENTS } from './events/notifications';
import { EVENTS as PRODUCT_EXPLORATION_EVENTS } from './events/product-exploration';
import { EVENTS as RECOMMENDATIONS_EVENTS } from './events/recommendations';
import { EVENTS as RV_EVENTS } from './events/rv-events';
import { EVENTS as SEED_RECOMMENDATION_EVENTS } from './events/seed-recommendation';
import { EVENTS as USER_EVENTS } from './events/user';
import { EVENTS as VISIT_REPORTS_EVENTS } from './events/visit-report';
import { EVENTS as WALKTHROUGH_EVENTS } from './events/walkthrough';
import { EVENTS as WEEDS_EVENTS } from './events/weeds';

export const MIXPANEL_EVENTS = {
    ...ACTIVITIES_EVENTS,
    ...CROP_PROTECTION_EVENTS,
    ...SEED_RECOMMENDATION_EVENTS,
    ...FIELD_EVENTS,
    ...FIELD_REGISTRY_EVENTS,
    ...USER_EVENTS,
    ...N_SMART_RECOMMENDATION_EVENTS,
    ...WEEDS_EVENTS,
    ...ASK_AN_EXPERT_EVENTS,
    ...NOTIFICATIONS_EVENTS,
    ...CROP_MOITORING_EVENTS,
    ...CARBON_CALCULATOR_EVENTS,
    ...CATALOG_EVENTS,
    ...PRODUCT_EXPLORATION_EVENTS,
    ...H2H_EVENTS,
    ...MAPS_EVENTS,
    ...SEED_QUALITY_EVENTS,
    ...RV_EVENTS,
    ...GROWERS_EVENTS,
    ...RECOMMENDATIONS_EVENTS,
    ...VISIT_REPORTS_EVENTS,
    ...WALKTHROUGH_EVENTS,
};

export const mpTrackEvent = <E extends keyof typeof MIXPANEL_EVENTS>(
    event: E,
    properties: Parameters<(typeof MIXPANEL_EVENTS)[E]>[0],
    /**
     * `{ transport: 'sendBeacon', send_immediately: true }` for events fired while the page is
     * going away: requests are batched by default, and a queued event would miss the unload.
     */
    options?: { transport?: 'xhr' | 'sendBeacon'; send_immediately?: boolean }
) => {
    try {
        return Mixpanel.track(event, properties, options);
    } catch (error) {
        return;
    }
};
